<div *ngIf="model != null && option != null && (!model.readOnly || selection?.selected) "
  [style.background-color]="option.color != null ? option.color : null" [formGroup]="formGroup">
  <sc-flex [startAligned]="true" *ngIf="!model.readOnly">
    <sc-checkbox-field formControlName="selection"
      [label]="('' | translate:[option.nameDictionaryKey, translationService.language])+(model.optionStatus.get(option.id)?.includes('required')?'*':'')">
    </sc-checkbox-field>
  </sc-flex>
  <div *ngIf="model.readOnly">
    <sc-dictionary-label [dictionaryKey]="option.nameDictionaryKey"></sc-dictionary-label>
  </div>

  <div class="readonly-label"
  *ngIf="showDriverHints && option.hintDriverDictionaryKey != null && (selection?.selected || option.allwaysShowHint) && translationService.translationExists(option.hintDriverDictionaryKey, translationService.language)">
    <sc-hint-legacy [dictionaryKey]="option.hintDriverDictionaryKey"></sc-hint-legacy>
  </div>

  <div class="option-details no-field-space" *ngIf="selection?.selected">
    <sc-flex vertical stretchContent
      *ngIf="loadingEnabled && (option.amountOfPallettesMandatory || option.amountOfBoxesMandatory || option.amountInKilogrammMandatory || option.amountInLiterMandatory || option.amountOthersMandatory)">

      <sc-content-spacer vertical [half]="true"></sc-content-spacer>
      <div class="title-cargo">
        <sc-dictionary-label dictionaryKey="shared.transport-options-editor.amount-of-cargo"></sc-dictionary-label>
      </div>

      <sc-number-field *ngIf="option.amountOfPallettesMandatory && !model.readOnly" formControlName="amountOfPallettes" labelDictionaryKey="tmc-yard.entity.transport-option.amount-of-pallettes">
      </sc-number-field>
      <div class="readonly-label"
        *ngIf="option.amountOfPallettesMandatory && selection.amountOfPallettes > 0 && model.readOnly">
        <sc-content-spacer vertical [half]="true"></sc-content-spacer>
        <sc-dictionary-label
          dictionaryKey="tmc-yard.entity.transport-option.amount-of-pallettes"></sc-dictionary-label>:&nbsp;
        {{selection.amountOfPallettes}}
      </div>

      <sc-number-field *ngIf="option.amountOfBoxesMandatory && !model.readOnly" formControlName="amountOfBoxes" labelDictionaryKey="tmc-yard.entity.transport-option.amount-of-boxes">
      </sc-number-field>
      <div class="readonly-label"
        *ngIf="option.amountOfBoxesMandatory && selection.amountOfBoxes > 0 && model.readOnly">
        <sc-content-spacer vertical [half]="true"></sc-content-spacer>
        <sc-dictionary-label
          dictionaryKey="tmc-yard.entity.transport-option.amount-of-boxes"></sc-dictionary-label>:&nbsp;
        {{selection.amountOfBoxes}}
      </div>

      <sc-number-field *ngIf="option.amountInKilogrammMandatory && !model.readOnly" formControlName="amountInKilogramm" labelDictionaryKey="tmc-yard.entity.transport-option.amount-in-kilogramm">
      </sc-number-field>
      <div class="readonly-label"
        *ngIf="option.amountInKilogrammMandatory && selection.amountInKilogramm> 0 && model.readOnly">
        <sc-content-spacer vertical [half]="true"></sc-content-spacer>
        <sc-dictionary-label
          dictionaryKey="tmc-yard.entity.transport-option.amount-in-kilogramm"></sc-dictionary-label>:&nbsp;
        {{selection.amountInKilogramm}}
      </div>

      <sc-number-field *ngIf="option.amountInLiterMandatory && !model.readOnly" formControlName="amountInLiter" labelDictionaryKey="tmc-yard.entity.transport-option.amount-in-liter">
      </sc-number-field>
      <div class="readonly-label" *ngIf="option.amountInLiterMandatory && selection.amountInLiter> 0 && model.readOnly">
        <sc-content-spacer vertical [half]="true"></sc-content-spacer>
        <sc-dictionary-label
          dictionaryKey="tmc-yard.entity.transport-option.amount-in-liter"></sc-dictionary-label>:&nbsp;
        {{selection.amountInLiter}}
      </div>

      <sc-string-field *ngIf="option.amountOthersMandatory && !model.readOnly" formControlName="amountOthers" labelDictionaryKey="tmc-yard.entity.transport-option.amount-others">
      </sc-string-field>
      <div class="readonly-label"
        *ngIf="option.amountOthersMandatory && selection.amountOthers?.trim().length > 0 && model.readOnly">
        <sc-content-spacer vertical [half]="true"></sc-content-spacer>
        <sc-dictionary-label
          dictionaryKey="tmc-yard.entity.transport-option.amount-others"></sc-dictionary-label>:&nbsp;
        {{selection.amountOthers}}
      </div>

    </sc-flex>
    <sc-flex *ngIf="option.hasParameter && !model.readOnly">
      <app-transport-option-parameter formControlName="parameter"
        [transportOption]="option"></app-transport-option-parameter>
    </sc-flex>

    <div class="readonly-label" *ngIf="option.hasParameter && model.readOnly && selection">
      <sc-content-spacer vertical [half]="true"></sc-content-spacer>
      <sc-dictionary-label [dictionaryKey]="option.parameterNameDictionaryKey"></sc-dictionary-label>:&nbsp;
      <ng-container *ngFor="let param of selection.parameterValues; let i = index">
        <ng-container *ngIf="i > 0">
          &nbsp;,
        </ng-container>
        <sc-dictionary-label [dictionaryKey]="param.valueDictionaryKey"></sc-dictionary-label>
      </ng-container>
    </div>

    <ng-container *ngFor="let subOption of option.options">
      <app-transport-option-entry *ngIf="showInternalTransportOptions || subOption.onlyInternal !== true"
        [option]="subOption" [model]="model"
        [showDriverHints]="showDriverHints"></app-transport-option-entry>
    </ng-container>
  </div>
</div>
